import React from 'react';
import { ICON_SHAPES } from './iconShapes.js';
/** A single-colour stroke icon. It takes the current text colour and is always hidden from assistive technology. */
export function Icon({ name, size = 24 }) {
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false", "data-icon": name }, ICON_SHAPES[name]));
}
//# sourceMappingURL=Icon.js.map